module.exports = __webpack_public_path__ + "img/Blackstone-logo.71a15d2c.png";